// extracted by mini-css-extract-plugin
export default {"modal":"index-module__modal___jPAt7","wrapper":"index-module__wrapper___u9ONQ","btn":"index-module__btn___CwkjI"};